import { requests, mainApiRoot } from './index'

export const Auth = {
  current: () => requests.get(mainApiRoot, '/user'), // can be 1 user in a larger account
  account: () => requests.get(mainApiRoot, '/account'),
  gdpr: () => requests.get(mainApiRoot, '/account/gdpr-download'),
  login: (email, password) =>
    requests.post(mainApiRoot, '/user-token', { auth: { email, password } }),
  register: (email, password, firstName, lastName) =>
    requests.post(mainApiRoot, '/sign-up', {
      user: {
        firstName,
        lastName,
        email,
        password
      }
    }),
  update: (id, payload) => requests.put(mainApiRoot, `/account/users/${id}`, payload)
}